// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3V8qA","col":"styles_col__2I_Oo"};